define([
    'app/controllers/shoppingCartController',
    'app/controllers/klarnaController',
], function (ShoppingCartController, KlarnaController) {
    var shoppingCartController = false;
    var klarnaController = false;

    shoppingCartController = new ShoppingCartController();
    klarnaController = new KlarnaController();

    if (partyking.common.models.shoppingcart.isPreorder()) {
        partyking.common.models.messages.warning(
            'inline',
            '<strong>OBS!</strong> <br>Din varukorg innehåller beställningsvaror vilket medför en leveranstid på 7 - 14 arbetsdagar'
        );
    }

    const handleCheckoutBannerClicked = () => {
        if (partyking.common.models.shoppingcart.hasProducts())
            return partyking.common.messages.checkoutMessages.areYouSureYouWantToLeave();
        window.location.href = '/';
    };

    const checkoutBanner = document.getElementById('checkout-banner-link');
    if (checkoutBanner)
        checkoutBanner.onclick = handleCheckoutBannerClicked;

    klarnaController.init();
});
